export const bindEvent = (chartModel: object, postComponents) => {
  for (const event of chartModel.events) {
    switch (event.eventType) {
      case 'click':
        chartModel.series = chartModel.highchartsData.series.map((serie: object) => {
          return {
            ...serie,
            events: {
              click: function (e: object): void {
                const eventProperties = {
                  category: {},
                  x: e.point.x,
                  y: e.point.y,
                };
                if ((e.point?.category !== undefined) &&
                  (e.point?.category !== null)) {
                  eventProperties.category = e.point.category;
                }
                postComponents([{ component: chartModel.id, event: eventProperties }])
              },
            },
          };
        });
        break;
      default:
        break;
    }
  }
};

export const bindFormatter = (chartModel: object) => {
  if (!chartModel.chart) return
  switch (chartModel.chart.formatter) {
    case 'delta':
      chartModel.chart.marginRight = 50;
      chartModel.series = chartModel.series.map((serie: object) => {
        return {
          ...serie,
          dataLabels: {
            enabled: true,
            useHTML: true,
            inside: false,
            align: 'left',
            formatter: function () {
              const delta = this.point.delta;
              if (delta !== undefined) {
                const arrow = delta > 0 ? '↑' : '↓';
                const color = delta > 0 ? 'blue' : 'red';
                return '<div style="position: relative; left: -55px">' + '<span>' + this.point.y + '</span>' + '<span style="margin-left: 5px; color: ' + color + '">' + arrow + Math.abs(delta) + "%" + '</span></div>';
              } else {
                return this.y;
              }
            }
          }
        }
      });
      chartModel.chart.events = {
        render(e: object) {
          e.target.series.forEach((serie: object) => {
            serie.points.forEach((point: object) => {
              point.dataLabel.attr({
                x: e.target.plotWidth
              })
            })
          })
        }
      }
      break
    default:
      break;
  }
}

export const checkHighchartsRegistered = (): boolean => {
  return (
    typeof window !== "undefined" &&
    ((window._Highcharts && window._Highcharts.charts.length > 0) || 
     (window.Highcharts && window.Highcharts.charts.length > 0))
  );
};

export const formatSeriesNoData = (chartModel: object) => {
  if (!chartModel?.series || !Array.isArray(chartModel.series) || chartModel.series.length === 0) {
    applyNoDataSpacing(chartModel);
    return;
  }

  const isSeriesEmpty = chartModel.series.every(
    (series) => !series.data || series.data.length === 0
  );


  if (isSeriesEmpty) {
    applyNoDataSpacing(chartModel);
  }
};

const applyNoDataSpacing = (chartModel: object) => {
  if (!chartModel.chart) chartModel.chart = {};
  chartModel.chart.spacingLeft = 0;
  chartModel.chart.spacingRight = 0;
  chartModel.chart.spacingTop = 0;
  chartModel.chart.spacingBottom = 0;
};
